// https://github.com/exceljs/exceljs
import ExcelJs from "exceljs";
import { saveAs } from "file-saver";

type ExcelHeader = {
  /** 엑셀 헤더 명 */
  header: string;
  /** 헤더와 데이터가 매핑될 키 */
  key: string;
  /** 엑셀 너비 */
  width?: number;
  /** 데이터 필수값 여부 */
  required?: boolean;
  /** 데이터 유효범위 (required = true 일때만 동작한다.) */
  chkEnum?: string[];
  /** 중복값 여부 (required = true 일때만 동작한다.) */
  duplicate?: boolean;
  /** 공통코드 변환  */
  cmmnCodeId?: string;
  /** 데이터 타입 (DB 삽입 시 변환용) */
  type?: "string" | "number" | "date" | "checkbox";
};

type ExcelItem = {
  sheetName: string;
  items: Record<string, unknown>[];
  headers?: ExcelHeader[]; // 시트별 헤더 (옵션)
};

/**
 * 엑셀 다운로드
 */
const excelDown = (
  headers: ExcelHeader[],
  items: ExcelItem[],
  fileNm: string,
  type?: string // 엑셀 양식 다운로드일 경우 사용 : "excelForm"
): void => {
  const wb = new ExcelJs.Workbook();

  items.forEach((item) => {
    const ws = wb.addWorksheet(item.sheetName as string);
    // 시트별 헤더가 있으면 우선 사용, 없으면 기본 헤더 사용
    const currentHeaders = item.headers || headers;
    ws.columns = currentHeaders;

    // 빈 값들을 "-"로 변환 ( type 이 excelForm 아닐때만 동작 )
    if (type !== "excelForm") {
      const processedItems = item.items.map((row) => {
        const processedRow: Record<string, unknown> = {};
        currentHeaders.forEach((header) => {
          const value = row[header.key];
          // null, undefined, 빈 문자열을 "-"로 변환
          processedRow[header.key] =
            value === null || value === undefined || value === "" ? "-" : value;
        });
        return processedRow;
      });
      ws.insertRows(2, processedItems as unknown as Record<string, unknown>[]);
    } else {
      ws.insertRows(2, item.items as unknown as Record<string, unknown>[]);
    }

    // Header style 설정
    ws.getRow(1).font = { bold: true };
    ws.getRow(1).alignment = { vertical: "middle", horizontal: "center" };
    ws.getRow(1).eachCell({ includeEmpty: false }, (cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "e6f0fe" },
      };
    });

    // 2행부터 데이터 행 처리 (오류 데이터 처리 _ 엑셀 업로드시 활용)
    for (let rowIdx = 2; rowIdx <= ws.rowCount; rowIdx++) {
      const row = ws.getRow(rowIdx);
      row.eachCell({ includeEmpty: true }, (cell) => {
        if (typeof cell.value === "string" && cell.value.startsWith("text-error|")) {
          // text-error| 뒤의 값만 남기기
          cell.value = cell.value.split("|")[1];
          // 폰트 색 빨간색으로 변경
          cell.font = { ...cell.font, color: { argb: "FF0000" } };
        }
      });
    }
  });

  // 엑셀 다운로드
  wb.xlsx.writeBuffer().then((data) => {
    saveAs(new Blob([data]), `${fileNm}.xlsx`);
  });
};

export { excelDown };
export type { ExcelHeader, ExcelItem };
